import { quickFacts, keywords } from "@/mocks/home";

export default function IntroSection() {
  return (
    <section id="intro" className="section-anchor w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl">
          <span className="text-xs font-label tracking-[0.2em] text-accent-600">作品速览 / OVERVIEW</span>
          <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950">
            一部被称为“青春白月光”的经典番剧
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            《我的家庭教师》（原名《家庭教師ヒットマンREBORN!》）由天野明创作，漫画连载于集英社《周刊少年Jump》，
            同名电视动画于 2006 年开播、2010 年完结。它既是无数观众的入坑之作，也是很多人反复重温的热血经典。
            下表把最常被问到的基础信息集中在一起，方便你先建立一个整体印象。
          </p>
        </div>

        <div className="reveal mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {quickFacts.map((f) => (
            <div
              key={f.label}
              className="rounded-lg bg-background-100 border border-background-200 px-4 py-4"
            >
              <p className="text-xs font-label text-secondary-700">{f.label}</p>
              <p className="mt-2 text-sm text-foreground-900 leading-relaxed">{f.value}</p>
            </div>
          ))}
        </div>

        <div className="reveal mt-8 rounded-lg bg-primary-50 border border-primary-200 px-5 py-5 md:px-8 md:py-6">
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <i className="ri-price-tag-3-line text-primary-700" />
            <span className="text-sm font-label text-primary-800">本页涉及的常见检索词</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {keywords.map((k) => (
              <span
                key={k}
                className="px-3 py-1.5 rounded-full bg-background-50 border border-primary-200 text-xs md:text-sm text-foreground-800"
              >
                {k}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}